import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Save } from 'lucide-react';
import { centres as centresData } from '../../data/mockData';

function FormulaireCentre({ user }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditing = !!id;

  const [formData, setFormData] = useState({
    nom: '',
    adresse: '',
    codePostal: '',
    ville: '',
    telephone: '',
    email: '',
    latitude: '',
    longitude: '',
    actif: true,
  });

  useEffect(() => {
    if (isEditing) {
      const centre = centresData.find(c => c.id === parseInt(id));
      if (centre) {
        setFormData({
          nom: centre.nom,
          adresse: centre.adresse,
          codePostal: centre.codePostal,
          ville: centre.ville,
          telephone: centre.telephone,
          email: centre.email,
          latitude: centre.coordonneesGPS?.latitude || '',
          longitude: centre.coordonneesGPS?.longitude || '',
          actif: centre.actif,
        });
      }
    }
  }, [id, isEditing]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simulation de la sauvegarde
    console.log('Centre sauvegardé:', formData);
    
    // Redirection vers la liste
    navigate('/centres');
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <button onClick={() => navigate('/centres')} className="btn-back">
            <ArrowLeft size={20} />
            Retour
          </button>
          <h1>{isEditing ? 'Modifier le centre' : 'Nouveau centre'}</h1>
        </div>
      </div>

      <div className="form-container">
        <form onSubmit={handleSubmit} className="form-card">
          <div className="form-section">
            <h2>Informations générales</h2>
            
            <div className="form-group">
              <label htmlFor="nom">Nom du centre *</label>
              <input
                type="text"
                id="nom"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="telephone">Téléphone *</label>
                <input
                  type="tel"
                  id="telephone"
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>Adresse</h2>
            
            <div className="form-group">
              <label htmlFor="adresse">Adresse *</label>
              <input
                type="text"
                id="adresse"
                name="adresse"
                value={formData.adresse}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="codePostal">Code postal *</label>
                <input
                  type="text"
                  id="codePostal"
                  name="codePostal"
                  value={formData.codePostal}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="ville">Ville *</label>
                <input
                  type="text"
                  id="ville"
                  name="ville"
                  value={formData.ville}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>Coordonnées GPS (optionnel)</h2>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="latitude">Latitude</label>
                <input
                  type="number"
                  step="any"
                  id="latitude"
                  name="latitude"
                  value={formData.latitude}
                  onChange={handleChange}
                  placeholder="Ex: 48.8566"
                />
              </div>

              <div className="form-group">
                <label htmlFor="longitude">Longitude</label>
                <input
                  type="number"
                  step="any"
                  id="longitude"
                  name="longitude"
                  value={formData.longitude}
                  onChange={handleChange}
                  placeholder="Ex: 2.3522"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <div className="form-group-checkbox">
              <input
                type="checkbox"
                id="actif"
                name="actif"
                checked={formData.actif}
                onChange={handleChange}
              />
              <label htmlFor="actif">Centre actif</label>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={() => navigate('/centres')} className="btn btn-secondary">
              Annuler
            </button>
            <button type="submit" className="btn btn-primary">
              <Save size={20} />
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FormulaireCentre;

